module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading-fragment"
  }, [_c('div', {
    staticClass: "dataTables_processing panel panel-default"
  }, [_vm._v("\n            " + _vm._s(_vm.t('Processing')) + "...\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.opened = !_vm.opened
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Fullscreen')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('default-chart', {
    attrs: {
      "labels": _vm.labels,
      "items": _vm.items,
      "height": 75,
      "options": _vm.chartOptions.default
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fullscreen-chart",
    class: {
      'opened': _vm.opened
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('datepicker', {
    on: {
      "input": _vm.onInput,
      "initialized": _vm.onInput
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.opened = !_vm.opened
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Hide')))])]), _vm._v(" "), _c('default-chart', {
    attrs: {
      "labels": _vm.labels,
      "items": _vm.items,
      "height": 135,
      "options": _vm.chartOptions.fullscreen
    }
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41bb1119!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product/PriceHistoryCeneo.vue
// module id = 1277
// module chunks = 2